import React, { useContext, useEffect, useState } from 'react';
import {FormDataContext} from "../../contexts/FormDataContext";
import {
  FormControl, IconButton,
  InputLabel,
  MenuItem,
  Select, styled,
} from '@mui/material';
import { SectionHeading } from '../SectionHeading';
import { IntakeAutocomplete } from '../IntakeAutocomplete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export const LocationsAutocomplete = () => {
  const [nationalLocations, setNationalLocations] = useState([]);
  const [internationalLocations, setInternationalLocations] = useState([]);
  const [isAllLocationsOpen, setIsAllLocationsOpen] = useState(false);

  const {
    locations,
    selectedLocationsAll,
    setSelectedLocationsAll,
    selectedLocations,
    setSelectedLocations,
    preferencesFormDisabled,
    setIsFormDataChanged,
    isLocationsAllSelected,
    setIsLocationsAllSelected,
  } = useContext(FormDataContext);

  useEffect(() => {
    if (locations.length > 0) {
      const filteredNational = locations.filter(
        location => !parseInt(location.international)
      );
      setNationalLocations(filteredNational);
      setInternationalLocations(locations.filter(
        location => parseInt(location.international)
      ));
    }
  }, [locations]);

  const handleAllLocationsChange = event => {
    const selectedValue = event.target.value;
    setSelectedLocationsAll(selectedValue);
    setIsLocationsAllSelected(true);
    setIsFormDataChanged(true);
  };

  const SelectIconButton = styled(IconButton)(({ theme }) => ({
    padding: "2px",
    right: "9px",
    ".MuiSvgIcon-root": {
      fontSize: "2rem"
    }
  }));

  return (
    <>
      <SectionHeading>
        Locations
      </SectionHeading>

      <FormControl fullWidth sx={{marginTop: '10px'}} disabled={preferencesFormDisabled}>
        {!isLocationsAllSelected &&
          <InputLabel id="labelAllLocations" shrink={false}>All locations?</InputLabel>
        }
        <Select
          labelId={!isLocationsAllSelected ? "labelAllLocations" : ""}
          id="selectAllLocations"
          value={selectedLocationsAll}
          onChange={handleAllLocationsChange}
          inputProps={isLocationsAllSelected ? {
            "aria-label": "All locations?"
          } : {}}
          IconComponent={() => (
            <SelectIconButton
              aria-label="Open"
              size="small"
              onClick={() => setIsAllLocationsOpen(!isAllLocationsOpen)}
            >
              {
                isAllLocationsOpen
                  ? <ExpandLessIcon/>
                  : <ExpandMoreIcon/>
              }
            </SelectIconButton>
          )}
          open={isAllLocationsOpen}
          onOpen={() => setIsAllLocationsOpen(true)}
          onClose={() => setIsAllLocationsOpen(false)}
        >
          <MenuItem value="" disabled>
            All locations?
          </MenuItem>
          <MenuItem value={true}>Yes, I'm interested in any location.</MenuItem>
          <MenuItem value={false}>No, I'm only interested in specific locations.</MenuItem>
        </Select>
      </FormControl>
      {nationalLocations.length > 0 &&
        <IntakeAutocomplete
          label="national locations"
          options={nationalLocations}
          selectedTaxonomyTermIds={selectedLocations}
          setSelectedTaxonomyTermIds={setSelectedLocations}
          getOptionLabel={option => option.extendedName}
          disabled={preferencesFormDisabled}
          filterOptions={(options, { inputValue }) => {
            return  options.filter(option => {
              const isNameMatch = option.extendedName.toLowerCase().includes(inputValue.toLowerCase());
              if (isNameMatch) {
                return true;
              }
              let isStateNameMatch = false;
              if (option.stateName) {
                isStateNameMatch = option.stateName.toLowerCase().includes(inputValue.toLowerCase());
              }
              return isStateNameMatch
            });
          }}
        />
      }
      {internationalLocations.length > 0 &&
        <IntakeAutocomplete
          label="international locations"
          options={internationalLocations}
          selectedTaxonomyTermIds={selectedLocations}
          setSelectedTaxonomyTermIds={setSelectedLocations}
          getOptionLabel={option => option.extendedName}
          disabled={preferencesFormDisabled}
        />
      }
    </>
  );
};
